import React, { Component } from "react";
import { stringify } from "qs";
import Iframe from "@/components/Iframe";

class IframeContainer extends Component {
  render() {
    const { baseUrl, orgId, activityBizId } = this.props;
    const queryParams = orgId ? { orgId, activityBizId } : { activityBizId };

    const IframeDom = Iframe({
      src: `https://rdp3.xiaoyuanhao.com/RDP-SERVER/rdppage/main/${baseUrl}?${stringify(
        queryParams
      )}`
    });

    return (
      <div style={{ padding: "9px 17px" }}>
        <IframeDom />
      </div>
    );
  }
}

export default IframeContainer;
